import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private readonly messageService: MessageService) {}
  /**
   * Show a success message in the toast
   * @param detail - The detailed content of the success message
   */
  showSuccess(detail: string): void {
    this.messageService.add({
      key: 'customToast',
      severity: 'success',
      summary: 'Success',
      detail: detail,
    });
  }
  /**
   * Show an error message in the toast
   * @param detail - The detailed content of the error message
   */
  showError(detail: string): void {
    this.messageService.add({
      key: 'customToast',
      severity: 'error',
      summary: 'Error',
      detail: detail,
    });
  }
  /**
   * Show an informational message in the toast
   * @param detail - The detailed content of the informational message
   */
  showInfo(detail: string): void {
    this.messageService.add({
      key: 'customToast',
      severity: 'info',
      summary: 'Info',
      detail: detail,
    });
  }
  /**
   * Show a warning message in the toast
   * @param detail - The detailed content of the warning message
   */
  showWarning(detail: string, customSummary?: string): void {
    this.messageService.add({
      key: 'customToast',
      severity: 'warn',
      summary: customSummary ?? 'Warning',
      detail: detail,
    });
  }
  /**
   * Clear all messages from the toast
   */
  clearMessages(): void {
    this.messageService.clear();
  }
}
